// extracted by mini-css-extract-plugin
export var nav = "nav-module--nav--QifKg";
export var logo = "nav-module--logo--1MwOM";
export var logoContainer = "nav-module--logoContainer--iC0uS";
export var right = "nav-module--right--3n3RP";
export var menu = "nav-module--menu--3QH6o";
export var buyBtnContainer = "nav-module--buyBtnContainer--2MnPX";
export var visible = "nav-module--visible--2yUdu";
export var buyButton = "nav-module--buyButton--2mc9t";
export var hamburger = "nav-module--hamburger--3zkzX";
export var open = "nav-module--open--2mXQQ";
export var menuName = "nav-module--menuName--Kdaie";
export var buyBtnBtm = "nav-module--buyBtnBtm--3_PeQ";
export var bg = "nav-module--bg--3_co1";